<template>
  <div class="content-middle">
    <div class="cont-con clearfix">
      <div class="cont-left hidden-xs">
        <div class="contl-header">
          掌上扫描器
          <button class="menu-button" id="open-button">Open Menu</button>
        </div>
        <div class="menu-wrap">
          <nav class="menu">
            <div class="icon-list">
              <router-link
                :to="{path: list.url, query: {index: index}}"
                :class="{'current': currentIndex == index}"
                v-for="(list, index) in lists"
                v-bind:key="index"
              >{{list.text}}</router-link>
            </div>
          </nav>
          <button class="close-button" id="close-button">Close Menu</button>
        </div>
      </div>
      <div class="cont-right">
        <div class="contr-header clearfix">
          <h4>{{bu04name}}</h4>
          <div class="contr-nav">
            <router-link to="/">首页</router-link>&gt;
            <router-link :to="{path:'/BU04',query: {index: 0}}">掌上扫描器</router-link>
            &gt; {{bu04name}}
          </div>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
     this.bu04name = this.$route.meta.title;
    this.currentIndex = this.$route.query.index;
  },
  data() {
    return {
      currentIndex: 0,
      bu04name: "BU04",
      lists: [
        { text: "BU04PB", url: "/BU04/PB" },
       
      ]
    };
  },
  methods: {},
  watch: {
    $route(to, from) {
      if (to != undefined) {
        this.currentIndex = to.query.index;
        this.bu04name = to.meta.title;
      }
    }
  },
  components: {}
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/BU04/BU04index.vue